module.exports = __webpack_public_path__ + "img/spin1.81162da8.png";